module.exports = __webpack_public_path__ + "static/img1-726f5e9650134ea63ab34a41e017893d.png";